
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class TransportationMultiselect extends Vue {
    @Prop({ required: true, type: Array }) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: Number, default: undefined }) readonly max?: number;
    @Prop({ default: true, type: Boolean }) multiple!: boolean;
    @Prop({ default: "Select transportation methods", type: String }) readonly placeholder!: string;
    @Prop({ type: String, default: "" }) readonly getParentcontainerStyle?: string;

    // Static transportation options based on database constraint - these are the only options available
    transportationOptions: DropdownOption[] = [
      { id: 'driving', name: 'Driving' },
      { id: 'public_transit', name: 'Public Transit' },
      { id: 'cycling', name: 'Cycling' },
      { id: 'walking', name: 'Walking' }
    ];

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
